export enum GeneratedServiceStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",

  SUCCESSED = "SUCCESSED",
  SUCCEEDED = "SUCCEEDED",

  FAILED = "FAILED",
  CANCELED = "CANCELED",
  SUSPENDED = "SUSPENDED",
  UNKNOWN = "UNKNOWN",
}

export enum LoadingStatus {
  CREATE = "create",
  ENQUEUE = "enqueue",
  DEQUEUE = "dequeue",
  RUNNING = "running",
  SUCCESS = "success",
  ERROR = "error",
}

export const SUCCESS_STATUS = 0;
